module.exports = __webpack_public_path__ + "static/sampledesigner-ef8cbe2d776ec52f154dc55773f13946.jpg";